import React from "react";
import { useState, useEffect } from "react";
import {
  PlayFill,
  PauseFill,
  ChevronDoubleLeft,
  ChevronDoubleRight,
} from "react-bootstrap-icons";

// Data
import data from "../../../data/music.json";

// Components
import Magnetic from "../../Common/Magnetic/Magnetic";

// Context
import { useCookie } from "../../../context/CookieContext";

// SCSS
import "./MusicWindow.scss";

const MusicWindow = ({ setHoveredElement }) => {
  // Cookie
  const { cookieConsent, setShowBanner } = useCookie();

  // Music
  const [currentTrack, setCurrentTrack] = useState(
    data[Math.floor(Math.random() * data.length)],
  );
  const [isPlaying, setIsPlaying] = useState(false);

  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);

  const changeTrack = () => {
    const nextIndex = Math.floor(Math.random() * data.length);
    setCurrentTrack(data[nextIndex]);
  };

  useEffect(() => {
    let interval;

    const handleMessage = (event) => {
      if (event.origin !== "https://www.youtube.com") return;

      try {
        const json = JSON.parse(event.data);

        if (json.info) {
          if (json.info.duration !== undefined) setDuration(json.info.duration);
          if (json.info.currentTime !== undefined)
            setCurrentTime(json.info.currentTime);
          if (json.info.playerState === 0) changeTrack();
        }
      } catch (e) {}
    };

    window.addEventListener("message", handleMessage);

    if (isPlaying) {
      interval = setInterval(() => {
        const iframes = document.getElementsByTagName("iframe");
        for (let i = 0; i < iframes.length; i++) {
          iframes[i].contentWindow.postMessage(
            JSON.stringify({ event: "listening", id: currentTrack.id }),
            "https://www.youtube.com",
          );
        }
      }, 1000);
    }

    return () => {
      window.removeEventListener("message", handleMessage);
      clearInterval(interval);
    };
  }, [currentTrack, isPlaying]);

  const progressPercent = duration > 0 ? (currentTime / duration) * 100 : 0;

  const handleProgressClick = (e) => {
    if (duration === 0) return;

    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const clickedPercent = x / rect.width;
    const seekTime = duration * clickedPercent;

    const iframe = document.querySelector("iframe");
    if (iframe) {
      iframe.contentWindow.postMessage(
        JSON.stringify({
          event: "command",
          func: "seekTo",
          args: [seekTime, true],
        }),
        "https://www.youtube.com",
      );
    }
  };

  return (
    <div className="MusicWindow">
      <section className="Music">
        <div className="Music__Wrapper">
          <div className="Music__Cover">
            <img
              src={currentTrack.cover}
              alt={`${currentTrack.title} - ${currentTrack.artist}`}
              className="Music__Cover-Image"
            />
          </div>
          <div className="Music__Information">
            <h3 className="Music__Information-Title">{currentTrack.title}</h3>
            <span className="Music__Information-Artist">
              {currentTrack.artist}
            </span>
          </div>
          <div onClick={handleProgressClick} className="Music__Progress">
            <div
              style={{
                width: `${progressPercent}%`,
                transition: "width 0.5s linear",
              }}
              className="Music__Progress-Bar"
            />
          </div>
          <div className="Music__Buttons">
            <Magnetic
              as="button"
              type="button"
              setHoveredElement={setHoveredElement}
              onClick={() => {
                const prevTrack = data[Math.floor(Math.random() * data.length)];
                setCurrentTrack(prevTrack);
              }}
              className="Music__Button Music__Button-Control"
            >
              <ChevronDoubleLeft />
            </Magnetic>
            <Magnetic
              as="button"
              type="button"
              setHoveredElement={setHoveredElement}
              onClick={() => {
                if (cookieConsent === "accepted") {
                  setIsPlaying(!isPlaying);
                } else {
                  setShowBanner(false);
                  setTimeout(() => setShowBanner(true), 0);
                }
              }}
              className="Music__Button Music__Button-Play"
            >
              {isPlaying ? <PauseFill /> : <PlayFill />}
            </Magnetic>
            <Magnetic
              as="button"
              type="button"
              setHoveredElement={setHoveredElement}
              onClick={() => {
                const nextTrack = data[Math.floor(Math.random() * data.length)];
                setCurrentTrack(nextTrack);
              }}
              className="Music__Button Music__Button-Control"
            >
              <ChevronDoubleRight />
            </Magnetic>
          </div>
        </div>

        {/* Music */}
        <div style={{ display: "none" }}>
          {isPlaying && cookieConsent === "accepted" && (
            <iframe
              title="Music--Iframe"
              key={currentTrack.id}
              src={`https://www.youtube.com/embed/${currentTrack.youtubeId}?autoplay=1&mute=0&enablejsapi=1&origin=${window.location.origin}&widget_referrer=${window.location.origin}`}
              allow="autoplay; encrypted-media"
            ></iframe>
          )}
        </div>
      </section>
    </div>
  );
};

export default MusicWindow;
